import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { MetricKey, MetricQuery, MetricResult, MetricScope } from '../../interfaces/metrics';
import { DrilldownPanelComponent } from '../drilldown/drilldown-panel.component';

@Component({
  selector: 'bst-team-dashboard',
  templateUrl: './team-dashboard.component.html',
  styleUrls: ['../dashboard.component.scss', './team-dashboard.component.scss'],
  standalone: false,
})
export class TeamDashboardComponent {
  @Input() scope!: MetricScope;
  @Input() anchor = '';
  @Input() atCurrentWeek = false;
  @Output() memberSelected = new EventEmitter<{ userId: number; name: string }>();

  constructor(private dialog: NbDialogService, private router: Router) {}

  // The approval queue is a to-do list, so the card carries the action itself instead of
  // making the manager open a drawer to find the same link.
  goApprovals(): void {
    this.router.navigate(['/time-approvals']).catch(err => console.error('dashboard: navigation failed', err));
  }

  q(key: MetricKey): MetricQuery {
    return { key, scope: this.scope, period: { type: 'week', anchor: this.anchor } };
  }

  openDrill(result: MetricResult | undefined): void {
    if (!result) { return; }
    this.dialog.open(DrilldownPanelComponent, { context: { result }, dialogClass: 'drawer-right' });
  }

  openBucket(bucket: { start: string; rows: any[] }, result: MetricResult): void {
    const clone: any = { ...result, data: { bucketStart: bucket.start, rows: bucket.rows } };
    this.dialog.open(DrilldownPanelComponent, { context: { result: clone }, dialogClass: 'drawer-right' });
  }
}
